import { OvertimeListComponent } from './list-lembur.component';
export default OvertimeListComponent;
